import React from 'react'
import { IconVolume, IconVolumeOff } from '@tabler/icons-react'
import classNames from 'classnames'

export const VolumeSlider = ({ isDisabled, volume, handleVolumeChange }) => {
  const isMuted = volume === '0'

  const handleToggleMute = () => {
    if (isMuted) {
      handleVolumeChange('1')
    } else {
      handleVolumeChange('0')
    }
  }

  return (
    <div className="volume-container">
      <button
        type="button"
        className="volume-button"
        disabled={isDisabled}
        onClick={handleToggleMute}
      >
        {isMuted ? <IconVolumeOff className="status-critical" /> : <IconVolume />}
      </button>
      <div className="volume-slider-input-container">
        <input
          id="volume-slider"
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={volume}
          onChange={(event) => handleVolumeChange(event.target.value)}
          disabled={isDisabled}
          className={classNames('volume-slider', { disabled: isDisabled })}
        />
      </div>
    </div>
  )
}
